import { useProjectsStore } from '@/store/projects';
import Swal from 'sweetalert2';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

export default function useBoqLockRedirect() {
  const projectsStore = useProjectsStore();
  const router = useRouter();

  watch(() => projectsStore.project, (newValue) => {
    if(newValue && !newValue.boq_locked) {
      router.push({ name: 'BillOfQuantities', params: { projectId: newValue.id } });

      Swal.fire({
        title: `BoQ has not been locked for ${newValue.name}`,
        text: 'You cannot access the selected page until the BoQ has been locked. You have been redirected to the BoQ.',
        icon: 'warning',
      });
    }
  }, { immediate: true });
}
